import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader } from 'reactstrap';
import ReactCodeInput from 'react-code-input';
import { toast } from 'react-toastify';

class Code extends Component {
  state = {
    codeValue: '',
    codeValid: true,
    codeMatch: false,
    disabled: true
  }

  componentDidMount() {
    const prevPath = this.props.location.state.prevPath;
    const number = this.props.location.state.number;
    if (prevPath === '/dtc/2fa/text') {
      toast.info(
        <div>
          <h5>Verification code sent to (***) ***-{number}</h5>
          <small>You should receive a SMS text within 30 seconds</small>
        </div>
      );
    }
    if (prevPath === '/dtc/2fa/call') {
      toast.info(
        <div>
          <h5>We're calling you now at (***) ***-{number}</h5>
          <small>You should receive a call within 30 seconds</small>
        </div>
      );
    }
  }

  handleCodeValue = (value) => {
    this.setState({ codeValue: value });
    if (value.length === 5) {
      this.setState({ disabled: false });
    } else {
      this.setState({
        disabled: true,
        codeValid: true
      });
    }
  }

  handleSubmit = () => {
    (this.state.codeValue === '55555')
      ? this.setState({ codeMatch: true })
      : this.setState({ codeValid: false })
  }

  render() {
    const { codeValid, codeMatch } = this.state;

    if (codeMatch) {
      window.open('/dtc/loan-offer', '_self');
    }

    return (
      <div>
        {!codeValid &&
          <Alert color="danger" className="mb-3 animated fadeInUp">
            <h5 className="mb-0 text-dark">The code you entered does not match</h5>
            <small className="text-dark">
              <u><Link to="/dtc/2fa" className="text-dark">Send a new code</Link></u> or&nbsp;
              <u><a href="/dtc/verify/id-upload" className="text-dark">Verify another way</a></u>
            </small>
          </Alert>
        }
        <Card className="text-left dark-shadow mb-3 animated fadeInUp delay-200ms">
          <CardHeader>Enter Verification Code</CardHeader>
          <CardBody className="text-center">
            <p className="mb-3">Once you receive your code, enter it here:</p>
            <ReactCodeInput
              className={ `w-100 mb-2 ${ !codeValid ? 'invalid' : '' }` }
              type="number"
              fields={5}
              value={this.state.codeValue}
              onChange={this.handleCodeValue.bind(this.props.value)}
            />
            <Button color="primary" onClick={this.handleSubmit} disabled={this.state.disabled}>Verify</Button>
          </CardBody>
        </Card>
        <p className="animated fadeInUp delay-700ms">
          <strong>Didn’t receive a code?</strong><br />
          <Link to="/dtc/2fa">Send a new code</Link> or <a href="/dtc/verify/id-upload">Verify another way</a>
        </p>
      </div>
    )
  }
}

export default Code;
